<template>
    <!-- currentColor + the icon-secondary role, matching the `i-sorting-arrows`
         mask utility the desktop table headers use. The drawn #2F3C4A was that
         token's light value, so light is unchanged and dark now flips. -->
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="text-(--icon-secondary)"
    >
        <path
            d="M10 4L8 2L6 4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 12L8 14L6 12"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
